import {
  InteractionRequiredAuthError,
  InteractionStatus,
  InteractionType,
  SilentRequest,
} from '@azure/msal-browser';
import { AuthenticatedTemplate, useMsal, useMsalAuthentication } from '@azure/msal-react';
import Routing from 'Routing';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { useEffect } from 'react';
import Loader from 'shared/component/Loader';
import { setToken } from 'shared/reducers/appSlice';

const SecuredApp = () => {
  const dispatch = useAppDispatch();
  const connected = useAppSelector(state => state.app.token !== '');
  useMsalAuthentication(InteractionType.Redirect);
  const { instance, inProgress, accounts } = useMsal();

  useEffect(() => {
    if (!connected && inProgress === InteractionStatus.None && accounts.length > 0) {
      const accessTokenRequest: SilentRequest = {
        scopes: ['user.read'],
        forceRefresh: true,
        account: accounts[0],
      };

      instance
        .acquireTokenSilent(accessTokenRequest)
        .then(accessTokenResponse => {
          let token = accessTokenResponse.idToken;
          if (token) {
            dispatch(setToken(token));
          }
        })
        .catch(error => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
        });
    }
  }, [instance, accounts, inProgress, connected]);

  if (inProgress === InteractionStatus.Startup || !connected) {
    return (
      <div className="main-loader">
        <Loader />
      </div>
    );
  }

  return (
    <AuthenticatedTemplate>
      <Routing />
    </AuthenticatedTemplate>
  );
};

export default SecuredApp;
